import { createFileRoute } from "@tanstack/react-router";

import PendingPage from "../features/auth/PendingPage";

export const Route = createFileRoute('/pending')({
    component: PendingPage,
});
